import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchError } from "./commonSlice";

const initialState = {
  list: [],
  perPage: "",
  total: 0,
  loading: false,
};

export const getMillPurchaseList = createAsyncThunk(
  "get-mill-purchase",
  async (data, { dispatch }) => {
    try {
      const response = await axios.get("mill/purchase/list", { params: data });
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const createMillPurchase = createAsyncThunk(
  "create-mill-purchase",
  async (data, { dispatch }) => {
    try {
      const response = await axios.post("mill/purchase", data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const getByIdMillPurchase = createAsyncThunk(
  "edit-mill-purchase",
  async (id, { dispatch }) => {
    try {
      const response = await axios.get(`mill/purchase/${id}`);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const updateMillPurchase = createAsyncThunk(
  "update-mill-purchase",
  async ({ id, data }, { dispatch }) => {
    try {
      const response = await axios.put(`/mill/purchase/${id}`, data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const deleteMillPurchase = createAsyncThunk(
  "delete-mill-purchase",
  async (id, { dispatch }) => {
    try {
      const response = await axios.delete(`/mill/purchase/${id}`);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

const millPurchaseSlice = createSlice({
  name: "mill-purchase",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getMillPurchaseList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getMillPurchaseList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action?.payload?.data?.data?.millPurchaseList ?? [];
        state.perPage = action?.payload?.data?.data?.perPage ?? 1;
        state.total = action?.payload?.data?.data?.total ?? 0;
      })
      .addCase(getMillPurchaseList.rejected, (state, action) => {
        state.loading = false;
        state.list = "";
        state.perPage = "";
        state.total = "";
      });
  },
});

export default millPurchaseSlice.reducer;
